import { Network } from '@/lib/networkConfig';

export enum NetworkEnum {
  REGTEST = 'regtest',
  MUTINYNET = 'mutinynet',
  SIGNET = 'signet',
  MAINNET = 'mainnet',
}

export interface NetworkSettingsConfig {
  network: Network;
  masterContractId: string;
  guardianPubkey: string;
  guardians: Array<{ guardianUrl: string }>;
  ordUrl: string;
  esploraUrl: string;
  mempoolUrl: string;
  xchangeUrl: string;
}

export type SERVICE_DOMAIN_ENV = 'dev' | 'staging' | 'prod';
